export const getCurrentWeather = async (lat: number, lon: number) => {
  const headers = {
    "User-Agent": "butterfly-app (samuelho@iastate.edu)"
  };

  try {
    const pointRes = await fetch(
      `https://api.weather.gov/points/${lat},${lon}`,
      { headers }
    );
    const pointData = await pointRes.json();

    const stationUrl = pointData.properties.observationStations;
    const gridUrl = pointData.properties.forecastGridData;

    const stationRes = await fetch(stationUrl, { headers });
    const stationData = await stationRes.json();
    const stationId =
      stationData.features[0].properties.stationIdentifier;
    const weatherRes = await fetch(
      `https://api.weather.gov/stations/${stationId}/observations/latest`,
      { headers }
    );
    const weatherData = await weatherRes.json();
    const w = weatherData.properties;

    const gridRes = await fetch(gridUrl, { headers });
    const gridData = await gridRes.json();

    const maxTemp = gridData.properties.maxTemperature.values[0]?.value;
    const minTemp = gridData.properties.minTemperature.values[0]?.value;

    return {
      temperatureC: w.temperature?.value,
      windSpeedMps: w.windSpeed?.value,
      windDirectionDeg: w.windDirection?.value,
      humidity: w.relativeHumidity?.value,
      precipitationMm: w.precipitationLast6Hours?.value,
      description: w.textDescription,
      visibilityMeters: w.visibility?.value,
      pressurePa: w.barometricPressure?.value,
      maxTempC: maxTemp,
      minTempC: minTemp
    };

  } catch (err) {
    console.error("Weather fetch failed:", err);
    return null;
  }
};

export const getCurrentLocation = async (): Promise<GeolocationCoordinates | null> => {
  if (!navigator?.geolocation) {
    console.warn("Geolocation is not available in this browser.");
    return null;
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) => resolve(pos.coords),
      (err) => {
        console.warn("Unable to get current position, continuing without weather data:", err);
        resolve(null);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 60000
      }
    );
  });
};